module.exports = __webpack_public_path__ + "static/media/crocodile(23).fd2dc123.PNG";